import { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const TypographyVariants = {
  // New variants
  h1: 'leading-none text-3xl font-bold text-charcoal-900',
  h2: 'leading-none text-2xl font-bold text-charcoal-900',
  h3: 'leading-none text-xl font-bold text-charcoal-900',
  h4: 'text-base font-semibold text-charcoal-800',
  h5: 'text-sm font-semibold text-charcoal-800',
  base: 'text-base font-medium text-charcoal-500',
  sm: 'text-sm font-medium text-charcoal-500',
  xs: 'text-xs font-medium text-charcoal-500',
  label: 'text-sm font-medium text-charcoal-900',

  // Old variants
  // body1: 'font-bold leading-6',
  // body2: 'leading-6',
  // body3: 'text-sm leading-6',
  // body4: 'text-sm leading-4 tracking-wider',
  // body5: 'text-xs leading-3',
  // header3: 'font-bold text-sm leading-4 tracking-wider',
  // header4: 'font-bold text-xxs leading-3 tracking-wider',
  // header5: 'font-bold uppercase text-xxs leading-3 tracking-wider',
  // header6: 'font-bold leading-tight tracking-wider',
  // label4: 'font-bold text-xs leading-3',
  // label5: 'font-bold text-xxs leading-3 tracking-wider',
  // label6: 'font-bold text-xxxs leading-1 tracking-wider',
  // label7: 'font-bold text-xxs uppercase leading-3 tracking-super',
  // label8: 'font-bold text-xxxs uppercase leading-1 tracking-widest',
  // label9: 'font-semibold text-xs leading-3',

  // Start Gloo variants
  // glooHeader3: 'font-extrabold tracking-tight text-base',
  // glooHeader5: 'font-extrabold tracking-tight text-5xl',
  // glooHeader7: 'font-bold tracking-tight text-lg',
  // glooHeader10: 'font-extrabold tracking-tight leading-none text-5xl',
  // glooHeader13: 'font-bold text-xl',

  // glooBody1: 'font-base leading-6',
  // glooBody2: 'font-base text-sm leading-5',
  // glooBody3: 'font-base text-base leading-7',
  // glooBody4: 'font-semibold text-sm leading-5',
  // glooBody5: 'font-base leading-6 text-lg',
  // glooBody6: 'font-base text-xs',
  // glooBody7: 'font-base text-sm',
  // glooBody8: 'font-semibold text-sm leading-none',
  // glooBody9: 'font-semibold text-xs leading-none',
};

export interface TypographyProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  variant: keyof typeof TypographyVariants;
}

function Typography({ children, className, variant, ...rest }: TypographyProps) {
  return (
    <div className={twMerge(TypographyVariants[variant], className)} {...rest}>
      {children}
    </div>
  );
}

export default Typography;
